import { Observable } from 'rxjs';
import { IPosition } from '../interfaces/stadtbus/bus_stop'
import { provideSingleton } from '../inversify';

@provideSingleton(GeolocationService)
class GeolocationService {

  private available: boolean = false;

  public geolocationAvailable(): boolean {    
    return this.available;
  }

  public watchPosition(): Observable<IPosition> {
    return new Observable<IPosition>(observer => {
      const watchId = window.navigator.geolocation.watchPosition(
        (loc: any) => {
          this.available = true;
          observer.next({ latitude: loc.coords.latitude, longitude: loc.coords.longitude });
        },
        (err) => {
          this.available = false;
          console.error(err);
          console.log('geolocation cannot be accessed');
          observer.complete();
        },
        {
          enableHighAccuracy: false,
          timeout: 2000
        });

      return () => {
        window.navigator.geolocation.clearWatch(watchId);
      };
    });
  }
  
  public distanceInKmBetweenEarthCoordinates(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const earthRadiusKm = 6371;
  
    const dLat = this.degreesToRadians(lat2-lat1);
    const dLon = this.degreesToRadians(lon2-lon1);
  
    lat1 = this.degreesToRadians(lat1);
    lat2 = this.degreesToRadians(lat2);
  
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return earthRadiusKm * c;
  }

  public formatDistance(distanceInMeter: number): string {
    if(distanceInMeter < 150) {
      return distanceInMeter + "m";
    }else {
      return (distanceInMeter / 1000).toFixed(1) + "km";
    }
  }

  private degreesToRadians(degrees: number) {
    return degrees * Math.PI / 180;
  }

}

export default GeolocationService;



// WEBPACK FOOTER //
// ./src/api/geolocation_service.ts